import { createClient } from '@supabase/supabase-js'

// Configura tu URL y clave de acceso de Supabase
const supabaseUrl = "https://dhsozacxzvxytnctgliq.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRoc296YWN4enZ4eXRuY3RnbGlxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTc0NTM2MTYsImV4cCI6MjAzMzAyOTYxNn0.u8-0Ao0iOTJp5-bPnTO6Oc-SuGIj-NDNynjYExexdbQ";

// Crea un cliente de Supabase
const supabase = createClient(supabaseUrl, supabaseKey);

// Servicio para interactuar con Supabase
export const SupabaseService = {
  // Envía los datos del formulario a Supabase
  sendFormData: async (data: any) => {
    try {
      // Envía los datos al servicio de Supabase
      const { data: appointment, error } = await supabase
        .from("appointments")
        .insert([data]);

      if (error) {
        console.error("Error inserting data:", error.message);
      } else {
        console.log("Data inserted successfully:", appointment);
        // Aquí podrías implementar el envío de mensajes de texto o WhatsApp
      }
    } catch (error) {
      console.error("Error sending form data:", error);
    }
  },
};
